import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ResourceComponentProps,
  Filter,
  DateField,
  ReferenceField,
  ReferenceInput,
  AutocompleteInput,
  NumberField,
  FunctionField,
} from "react-admin";
import { millisecondsToHours } from "../../helpers/dates";

export const AlayaCareCancelCodeList = (props: ResourceComponentProps) => (
  <List
    {...props}
    bulkActionButtons={false}
    title="AlayaCare Cancel Codes"
    filters={
      <Filter {...props}>
        <ReferenceInput
          label="AlayaCareEnvironment"
          reference="AlayaCareEnvironment"
          source="alayaCareEnvironmentId"
        >
          <AutocompleteInput optionText="baseApiUrl" />
        </ReferenceInput>
      </Filter>
    }
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField
        sortable={false}
        label="AlayaCareEnvironment"
        reference="AlayaCareEnvironment"
        source="alayaCareEnvironment.id"
      >
        <TextField source="baseApiUrl" />
      </ReferenceField>
      <NumberField source="alayaCareCancelCodeId" />
      <FunctionField
        source="minDuration"
        label="Min Duration (hrs)"
        render={(serviceCode: any) =>
          millisecondsToHours(serviceCode.minDuration)
        }
      />
      <FunctionField
        source="maxDuration"
        label="Max Duration (hrs)"
        render={(serviceCode: any) =>
          millisecondsToHours(serviceCode.maxDuration)
        }
      />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);
